import { render, staticRenderFns } from "./BusAmenities.vue?vue&type=template&id=4b1d5270&scoped=true&"
import script from "./BusAmenities.vue?vue&type=script&lang=js&"
export * from "./BusAmenities.vue?vue&type=script&lang=js&"
import style0 from "./BusAmenities.vue?vue&type=style&index=0&id=4b1d5270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d5270",
  null
  
)

export default component.exports